import React, { useEffect, useContext, useState } from 'react'
import { ArrowForwardIcon, Grid, Link, Typography, Dialog } from '@hermes/web-components'
import Script from 'next/script'
import useTranslateMessage from '../../../../hooks/useTranslateMessage'
import { getHubspotData } from '../../../../constants/global'
import { AppDataContext } from '../../../../providers/AppData'
import { ModalPaper, ContainerForForm } from './styles'

const ImproveListingForm = () => {
  const translate = useTranslateMessage()
  const { locale } = useContext(AppDataContext)

  const [improveListingModalIsOpen, setImproveListingModalIsOpen] = useState(false)

  const closeImproveListingModal = () => setImproveListingModalIsOpen(false)

  useEffect(() => {
    if (improveListingModalIsOpen) {
      const hbsptFormData = getHubspotData(locale)
      window.hbspt.forms.create(hbsptFormData)
    }
  }, [improveListingModalIsOpen, locale])

  return (
    <>
      <Script type="text/javascript" src="https://js-eu1.hsforms.net/forms/embed/v2.js" />
      <Grid container alignItems="center" gap={1}>
        <ArrowForwardIcon
          sx={{
            fontSize: '16px',
            transform: 'rotate(-45deg)',
            display: 'block',
            color: 'primary.main'
          }}
        />
        <Link
          component="button"
          variant="caption"
          color="primary.main"
          onClick={() => setImproveListingModalIsOpen(true)}
        >
          <Typography variant="body1">{translate('improve_this_listing')}</Typography>
        </Link>
      </Grid>
      <Dialog
        sx={{ maxHeight: '100%' }}
        open={improveListingModalIsOpen}
        onClose={closeImproveListingModal}
        PaperComponent={ModalPaper}
      >
        <ContainerForForm id="hbs-form" />
      </Dialog>
    </>
  )
}

export default ImproveListingForm
